// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageQuestionSquareIcon from "@/assets/icons/message-question-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageQuestionSquareIconProps = Omit<IconProps, "name">;

export function MessageQuestionSquareIcon(props: MessageQuestionSquareIconProps): React.ReactNode {
  return <Icon name={messageQuestionSquareIcon} {...props} />;
}
